<template>
    <img alt="" src="/recommended.svg" />
</template>
<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class RecommendedIcon extends Vue {}

    export default RecommendedIcon
</script>
